export interface UniversalTag {
  id: string;
  name?: string;
  url?: string;
  consentConfig?: ConsentConfig;
}
export const isUniversalTag = (object: unknown): object is UniversalTag => {
  const tag = object as UniversalTag;
  return !!tag && tag.id !== undefined;
};

export interface ConsentConfig {
  enableAdvertiserConsentSignal?: boolean;
  enableAdvertiserLoyaltyOverride?: boolean;
}
